import { Directive, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[miqIndeterminate]',
  standalone: false,
})
export class IndeterminateDirective {
  @Input()
  set miqIndeterminate(value) {
    this.element.nativeElement.indeterminate = value;
  }

  constructor(private element: ElementRef) {}
}
